"use client";

import { useEffect, useState } from "react";
import { useChampignons } from "../../hooks/api/champignons";
import { Card } from "../../components/ui/card";
import { PageHeader } from "../../ui/layout/page-header";
import { ChampignonsList } from "../champignons/champignons-list";

export function BibliothequeChampignonsBrowse() {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(25);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [sortBy, setSortBy] = useState<string>("name");
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");

  useEffect(() => {
    const timer: ReturnType<typeof setTimeout> = setTimeout(
      () => setDebouncedSearch(searchTerm),
      300
    );
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, sortBy]);

  const { data, isLoading, error, refetch } = useChampignons({
    page,
    limit,
    search: debouncedSearch || undefined,
    sortBy,
    includeDeleted: false,
  });

  return (
    <div className="space-y-3">
      <PageHeader className="mb-0 space-y-1">
        <PageHeader.Title>Bibliothèque · Champignons</PageHeader.Title>
        <PageHeader.Description>
          Liste consultable des champignons phytosanitaires.
        </PageHeader.Description>
      </PageHeader>
      <Card className="p-3">
        <ChampignonsList
          champignons={data?.data ?? []}
          isLoading={isLoading}
          error={error}
          onView={() => { }}
          onEdit={() => { }}
          page={page}
          limit={limit}
          total={data?.meta.total ?? 0}
          sortBy={sortBy}
          onLimitChange={(nextLimit: number) => {
            setLimit(nextLimit);
            setPage(1);
            refetch();
          }}
          onSearchChange={(nextSearch: string) => {
            setSearchTerm(nextSearch);
            setPage(1);
            refetch();
          }}
          searchTerm={searchTerm}
          onPageChange={(nextPage: number) => {
            setPage(nextPage);
            refetch();
          }}
          handleSortChange={(nextSort: string) => {
            setSortBy(nextSort);
            refetch();
          }}
          showDeleted={false}
          onShowDeletedChange={() => { }}
          pageCount={data?.meta.totalPages ?? 0}
          mode="browse"
        />
      </Card>
    </div>
  );
}

